import React, { useContext, useState } from 'react';
import { neverop } from 'utils/noop';
import { useCarouselContext } from '../CarouselContext';
import { PreviewProviderProps, PreviewContextType } from './types';
import { Spacer, FallbackWidth } from './constant';
import usePreviewProvider from './hooks/usePreviewProvider';

export const defaultPreviewContext = {
    preview: undefined,
    samples: undefined,
    artworkLeft: Spacer,
    artworkWidth: FallbackWidth,
    isPreviewVisible: false,
    showPreview: neverop('PreviewContext', 'showPreview'),
    hidePreview: neverop('PreviewContext', 'hidePreview'),
    contentGroup: undefined,
    contentList: undefined,
    setSelectedContentList: neverop('PreviewContext', 'setSelectedContentList'),
    parentRef: { current: null },
};

export const PreviewContext = React.createContext<PreviewContextType>(
    defaultPreviewContext,
);

export const usePreviewContext = (): PreviewContextType =>
    useContext(PreviewContext);

export const PreviewProvider: React.FC<PreviewProviderProps> = ({
    contentGroup,
    children,
}): JSX.Element => {
    const { isPreviewAllowed } = useCarouselContext();
    const {
        preview,
        samples,
        artworkLeft,
        artworkWidth,
        isPreviewVisible,
        showPreview,
        hidePreview,
        parentRef,
    } = usePreviewProvider({ isPreviewAllowed: isPreviewAllowed });

    const [contentList, setSelectedContentList] = useState<string | undefined>(
        undefined,
    );

    return (
        <PreviewContext.Provider
            value={{
                preview,
                samples,
                artworkLeft,
                artworkWidth,
                isPreviewVisible,
                showPreview,
                hidePreview,
                contentGroup,
                contentList,
                setSelectedContentList,
                parentRef,
            }}
        >
            <>{children}</>
        </PreviewContext.Provider>
    );
};

export default PreviewProvider;
